import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import bugsnag from 'bugsnag-js'
import createPlugin from 'bugsnag-react'

import { ThemeProvider } from 'styled-components'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { muiTheme } from 'Assets/Styles/muiTheme'

import {
  configure as configureWs,
  setAPIKey as setWsAPIKey,
} from './shared/websockets'

// Bootstrap styles
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'
import 'rc-slider/assets/index.css'
// CSS
import 'nprogress/nprogress.css'
import './style.css'
import { theme } from './Assets/Styles/theme'
import register from './registerServiceWorker'

// Routers
import { MainRouter } from './Config/Routing/MainRouter'
import store from './Config/store'

import { authorization } from './Module/Auth/Auth'

const bugsnagClient = bugsnag({
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY || '',
  releaseStage: process.env.REACT_APP_NODE_ENV,
  notifyReleaseStages: ['uat', 'prod'],
})
const ErrorBoundary = bugsnagClient.use(createPlugin(React))

configureWs(WebSocket, store, process.env.REACT_APP_NODE_ENV)
if (authorization.isLogged()) setWsAPIKey(authorization.getAPIKey())

const user = authorization.getUser()
if (user) {
  const { id, firstName, lastName, email } = user
  bugsnagClient.user = { id, firstName, lastName, email }
}

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <MainRouter />
        </MuiThemeProvider>
      </ThemeProvider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
)
if (process.env.STAGE !== 'test') {
  register()
}



// WEBPACK FOOTER //
// ./src/index.js